import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  dataURLToBlob(dataURL: string): Blob {
    const byteString = atob(dataURL.split(',')[1]);
    const mimeType = dataURL.match(/data:(.*?);base64/)?.[1] || 'image/png' || 'image/jpg';
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeType });
  }

  handleError(error: HttpErrorResponse): Observable<never> {
    return throwError(() => new Error(error.message || error.statusText));
  }

  /**
   * 複数の動画を結合する
   * @param videoUrls 結合する動画のURL配列
   * @param transitionType トランジションタイプ ('none', 'fade', 'dissolve', 'wipe')
   * @param transitionDuration トランジション時間（秒）
   * @returns 結合された動画の情報
   */
  concatenateVideos(
    videoUrls: string[],
    transitionType: string = 'none',
    transitionDuration: number = 1
  ): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/video/concatenate`, {
      videoUrls,
      options: {
        transitionType,
        transitionDuration
      }
    });
  }
}
